import { useState, useEffect } from 'react';
import { Input, InputGroup, InputLeftAddon } from '@chakra-ui/react';

const isBlank = (v) => v === null || v === undefined || v === '';

const toDisplay = (centavos) => {
    if (centavos == null) return '';
    const c = Math.floor(Math.abs(centavos));
    const reais = Math.floor(c / 100);
    const cents = String(c % 100).padStart(2, '0');
    const reaisStr = reais === 0 ? '0' : reais.toLocaleString('pt-BR');
    return `${reaisStr},${cents}`;
};

/**
 * Input de moeda. Cada dígito entra pela direita: 1→0,01; 12→0,12; 123→1,23
 * `value` e `onChange` operam em reais (ex: 10.5).
 * Se `value` vier `null`/`undefined`/`''`, o campo começa em branco (em vez de "0,00") — útil
 * pra distinguir "nenhum valor informado ainda" de um valor real igual a zero.
 */
const CurrencyInput = ({ value, onChange, maxDigits = 15, mostrarSifrao = true, ...props }) => {
    const [centavos, setCentavos] = useState(() => (isBlank(value) ? null : Math.floor(Number(value) || 0)));

    useEffect(() => {
        const incoming = isBlank(value) ? null : Math.floor(Number(value) || 0);
        if (incoming !== centavos) setCentavos(incoming);
    }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

    const emit = (next) => {
        setCentavos(next);
        onChange?.(next);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Backspace') {
            e.preventDefault();
            emit(Math.floor((centavos || 0) / 10));
        } else if (e.key >= '0' && e.key <= '9') {
            e.preventDefault();
            const next = String(centavos || 0) + e.key;
            if (next.length <= maxDigits) emit(parseInt(next, 10));
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const digits = e.clipboardData.getData('text').replace(/\D/g, '');
        if (digits) {
            const num = parseInt(digits.slice(-maxDigits), 10);
            if (!isNaN(num)) emit(num);
        }
    };

    return (
        <InputGroup>
            {mostrarSifrao && <InputLeftAddon>R$</InputLeftAddon>}
            <Input
                value={toDisplay(centavos)}
                onKeyDown={handleKeyDown}
                onPaste={handlePaste}
                onChange={() => { }}
                placeholder="0,00"
                inputMode="numeric"
                {...props}
            />
        </InputGroup>
    );
};

export default CurrencyInput;
